
























import Vue from 'vue'
import ScrollFire from '@/views/mixin/ScrollFire'

Vue.mixin(ScrollFire)

export default
  data: () ->
    fire_scroll: true

  created: () ->
    @$options.scroll_target = '.episode2_1'
